import {useNavigate} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';
import {
    Alert,
    Button,
    List,
    Stack,
    Title
} from '@mantine/core';
import {AiOutlineHome} from 'react-icons/ai';

export const AuthErrorPage = () => {
    const navigate = useNavigate();

    return (
        <Stack gap="xl" align="center" style={{maxWidth: 600, margin: 'auto'}}>
            <Title order={2}>{I18n.get('Authentication Failed')}</Title>

            <Alert color="red" title={I18n.get('Sign-in could not be completed')}>
                {I18n.get('The authentication process failed. This can happen when:')}
                <List mt="sm" size="sm">
                    <List.Item>{I18n.get('Your account does not exist in the system — you may need to complete the onboarding process first')}</List.Item>
                    <List.Item>{I18n.get('The identity provider rejected the authentication request')}</List.Item>
                    <List.Item>{I18n.get('Your session has expired or is invalid')}</List.Item>
                </List>
            </Alert>

            <Alert color="blue" title={I18n.get('What to do next')}>
                <List size="sm">
                    <List.Item>{I18n.get('If you are a new user, please complete the onboarding process using the invitation link sent to your email')}</List.Item>
                    <List.Item>{I18n.get('If you have already onboarded, try signing in again')}</List.Item>
                    <List.Item>{I18n.get('If the problem persists, contact your administrator')}</List.Item>
                </List>
            </Alert>

            <Button
                onClick={() => navigate('/')}
                leftSection={<AiOutlineHome/>}
                size="md"
            >
                {I18n.get('Start Over')}
            </Button>
        </Stack>
    );
};
